import { render, staticRenderFns } from "./ganyu-detail.vue?vue&type=template&id=06e54fc7&scoped=true&"
import script from "./ganyu-detail.vue?vue&type=script&lang=ts&"
export * from "./ganyu-detail.vue?vue&type=script&lang=ts&"
import style0 from "./ganyu-detail.vue?vue&type=style&index=0&id=06e54fc7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e54fc7",
  null
  
)

export default component.exports